module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"status":"Status","active":"Ativo","description.create":"Confirme sua senha para concluir o cadastro.","description.edit":"Adquirente cadastrada"},"en-US":{"status":"Status","active":"Active","description.create":"Confirm your password to complete the registration.","description.edit":"Registered acquirer"}}')
  delete Component.options._Ctor
}
